export default "__VITE_ASSET__241decb1__"